<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useGtm } from '@/hooks/useGtm'
export default defineComponent({
  name: 'LenCategoryRender',
  props: {
    item: {
      type: Object,
      default: () => ({} as AnyObject),
    },
    activeMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['setMode'],
  setup(_, { emit }) {
    const { pushGtm } = useGtm()
    const refLenClear = ref()

    const setMode = (key) => {
      emit('setMode', key)
      pushGtm(refLenClear.value)
    }

    return {
      refLenClear,
      setMode,
    }
  },
})
</script>

<template>
  <div
    ref="refLenClear"
    class="col-4 relative-position cursor-pointer"
    :glasson-click="item.gtmKey"
    @click="setMode(item.key)"
  >
    <q-card
      v-ripple
      class="relative-position q-pa-sm" :class="[{ border: activeMode }]"
    >
      <div
        v-if="activeMode"
        class="absolute-top-right bg-transparent z-top"
        style="padding: 2px 4px"
      >
        <q-avatar
          class="shadow-3"
          color="secondary"
          text-color="white"
          size="sm"
        >
          <q-icon name="checked" size="16px" />
        </q-avatar>
      </div>
      <q-img
        style="height: 100px"
        :src="item.url"
        alt="len categories"
        fit="contain"
        fetchpriority="high"
      >
        <div
          class="
            absolute-center
            text-center text-dark
            bg-transparent
            full-width
          "
          style="padding: 0"
        >
          <div class="text-body2 text-weight-medium" :class="[item.className]">
            {{ item.label }}
          </div>
        </div>
      </q-img>
    </q-card>
  </div>
</template>
